import useTracksStore from '../tracks.store.tsx'
import { useHistoryStore } from '../history.store.tsx'

export const deleteTrack = (id: string): void => {
  useTracksStore.getState().deleteTrack(id)
  useHistoryStore.getState().saveSnapshot()
}
